// Auth
export const SET_LOADING = "SET_LOADING";
export const SIGNUP_USER = "SIGNUP_USER";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const GET_USER = "GET_USER";
export const AUTH_FAIL = "AUTH_FAIL";
export const CLEAR_ERROR = "CLEAR_ERROR";

// Forms
export const MANUFACTURER_DISPATCH = "MANUFACTURER_DISPATCH";
export const WAREHOUSE_DISPATCH = "WAREHOUSE_DISPATCH";
export const FORM_ERROR = "FORM_ERROR";
